import type { FaireProductEntity } from "../../entity_types/product";

export const apparel_socks_bridal: FaireProductEntity = {
  token: "apparel-socks-bridal",
  type: "product",
  name: "The Bridal Grip Sock",
  brandName: "Lucky Honey",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c52d10c9812a68d535e9c5e57dcc4d99904f0533e5488bcb66a155e03bcac253.jpeg",
  priceDollars: 9,
  msrpDollars: 18,
  freeShipping: false,
  weight: 0.15,
  dimensions: {
    width: 3,
    height: 2,
    depth: 1,
  },
  description:
    "Sheer grip sock designed for brides. Non-slip sole, elegant lace trim.",
  categoryTokens: ["cat_accessories"],
  tags: ["apparel", "socks", "bridal", "grip"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
